import Vue from 'vue';
import Component from 'vue-class-component';

// TO DO: This component has to be removed after the concept test around the designer is done.
@Component({
  components: {
    EdDesigner: () => import(/* EdDesigner */'@/components/designer/components/ed-designer/ed-designer.component.vue'),
  }
})
export default class Designer extends Vue {}